import ScaleToFit from "./ScaleToFit";
import ImageAdjustmentContainer from "./ImageAdjustmentContainer";
import DrawOnBandsIcon from './DrawOnBandsIconLarge';
import DrawRotatedRectIcon from './DrawRotatedRectIconLarge';
import Navbar from './Navbar';


function MenuItem({
  item,

  mode,
  selectedDrawingToolId,
  setSelectedDrawingToolId,
  image,
  imageId,
  temporaryAdjustments,
  setTemporaryAdjustments
}){

  if( typeof(item) === "object" ){

    return item;
  }

  return ({
    drawingOptions:() => {
      const options = NavbarOptions(mode);
      return <Navbar {...{onSelect:(_id) => setSelectedDrawingToolId(_id),selected:selectedDrawingToolId,spread:false,fontSize:10,options}}/>

    },
    //flex:() => <div class="flex-expand"/>,
    space:() => {
      return <div class="flex-expand"/>
    },
    line:() => <div style={{height:'100%',width:1,background:'#ccc'}}/>,
    imageAdjustments:() => {

      return <ImageAdjustmentContainer {...{
        imageId, 
        imageAdjustments:{
          ...image.adjustments,
          ...temporaryAdjustments
        },
        setTemporaryAdjustments
      }}/>

    }
  })[item]?.() || <div>UNDEFINED</div>
}






export default function ImageCroppingContainerToolbar(props){
  let {
    toolbar=["drawingOptions","space"],//,"imageAdjustments"],
    imageId,
  } = props;

  toolbar = ["drawingOptions","space"];

  let toolbarItems = toolbar.map(item => {
    return <MenuItem {...{ item, ...props }}/>
  })

  let isVirtualImage = imageId.includes('v_');


  return (
    <div style={{
      borderBottom:'1px solid #ccc',
      }}
      class="rel full-width">
      <div style={{
        alignItems:'center',
        pointerEvents:(isVirtualImage?'none':'auto'),
        opacity:(isVirtualImage?0:1),
      }} class="sg-row">
        {toolbarItems}
        <div class="flex-expand"/>
        <div style={{
          margin:8,
          marginRight:20,
          }}>
        {props?.nextButton}
        </div>
      </div>
    </div>
  )

}

function NavbarOptions(mode){

  if( mode === "regionChoice" ){
    return [];
  }

  return [
    {
      _id:0,
      tooltip:<DrawOnBandsIcon/>,
      label:"Line Crop",
    },
    {
      _id:1,
      tooltip:<DrawRotatedRectIcon/>,
      label:"2-Line Rect",
    },
    {
      _id:3,
      label:"Rectangle"
    }
    /*
        {
          _id:2,
          label:(
            <div style={{alignItems:'center'}} class="sg-row">
              <div>Fixed Ratio Crop </div>
              &nbsp;
              W:
              &nbsp;
              <input onChange={e => setGuidelineSpec({...guidelineSpec,w:Number(e.target.value)})} style={{width:30, fontSize:9, lineHeight:1}} type="number" min={1} defaultValue={1} disabled={selectedDrawingToolId!==2} value={guidelineSpec.w} />
              &nbsp;
              H:
              &nbsp;
              <input onChange={e => setGuidelineSpec({...guidelineSpec,h:Number(e.target.value)})} style={{width:30, fontSize:9, lineHeight:1}} type="number" min={1} defaultValue={1} disabled={selectedDrawingToolId!==2} value={guidelineSpec.h} />
            </div>
          )
        }*/
  ]
}
